function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import omit from 'lodash/omit';
import isObject from 'lodash/isObject';
import isFunction from 'lodash/isFunction';
import { formatLocalizationResource } from 'helpers/i18n';
export const transformSystemAlerts = (systemAlerts, systemAlertsSettings, localizationResources)=>systemAlerts.map((systemAlert)=>{
        const systemAlertSetting = systemAlertsSettings.find((alertSetting)=>alertSetting.alertConfigurationId === systemAlert.alertConfigurationId);
        if (!systemAlertSetting) {
            return null;
        }
        return _object_spread_props(_object_spread({}, systemAlert), {
            id: systemAlert.alertId.toString(),
            type: systemAlertSetting.type.toLowerCase(),
            message: formatLocalizationResource(localizationResources, systemAlertSetting.resourceKey, systemAlert.variables),
            actions: []
        });
    });
export const getAlertName = (alert)=>isObject(alert.message) ? `${alert.message.id}_${JSON.stringify(omit(alert.messageValues, [
        'supportEmail',
        'requestId'
    ]))}` : alert.message;
export const onAction = (action, dispatch)=>{
    if (isFunction(action)) {
        action();
    } else if (isObject(action)) {
        dispatch(action);
    }
};
